<template>
  <div>
    <HeaderClient />

    <v-container style="max-width: unset">
      <v-card class="pa-0 ma-1" elevation="0">
        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
              class="primary-input"
              hide-details
              outlined
              placeholder="Nome do cliente"
              v-model="filter.name"
              dense
              clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
              class="primary-input"
              hide-details
              outlined
              placeholder="E-mail do cliente"
              v-model="filter.email"
              dense
              clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                class="primary-input"
                hide-details
                outlined
                placeholder="CPF/CNPJ do cliente"
                v-model="filter.cpfCnpj"
                v-mask="(filter.cpfCnpj && filter.cpfCnpj.length <= 14) ? '###.###.###-##' : '##.###.###/####-##'"
                dense
                clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row cols="12" class="ma-0">
          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-text-field
                class="primary-input"
                hide-details
                outlined
                placeholder="Telefone do cliente"
                v-model="filter.phone"
                v-mask="'(##) #####-####'"
                dense
                clearable
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26">
                  mdi-magnify
                </v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-autocomplete
              hide-details
              outlined
              class="secondary-input"
              placeholder="Estado"
              append-icon="mdi-chevron-down"
              v-model="filter.state"
              :items="states"
              item-text="nome"
              item-value="sigla"
              dense
              clearable
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-select
              hide-details
              outlined
              class="secondary-input"
              placeholder="ordem"
              append-icon="mdi-chevron-down"
              item-text="text"
              item-value="value"
              v-model="filter.order"
              :items="orders"
              dense
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row cols="12" justify="end" class="ma-0">
          <v-col class="d-flex justify-end" cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
            <v-btn
                elevation="0"
                class="primary-button mr-2"
                outlined
                @click="getClients()"
            >
              <span style="font-size: 16px">Pesquisar</span>
            </v-btn>
            <v-btn
                elevation="0"
                class="terciary-button"
                outlined
                @click="reset"
            >
              <span style="font-size: 16px">Limpar filtros</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <br />
      <v-data-table
        class="content-table elevation-0 ma-1"
        loading-text="Carregando..."
        no-data-text="Nenhum cliente encontrado"
        hide-default-footer
        :headers="headers"
        :items="clients"
        :loading="loading"
        :items-per-page="pageSize"
        :header-props="headerProps"
        v-model="selectedUsers"
        show-select
        item-key="id"
        :single-select="false"
      >
        <template v-slot:[`item.state`]="{ item }">
          {{
            item.userAddress &&
            item.userAddress.length > 0 &&
            item.userAddress[0].state
              ? item.userAddress[0].state
              : "Sem registros"
          }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <section class="d-flex align-center">
            <v-btn
                width="76"
                height="35"
                outlined
                class="quinary-button ma-2"
                @click="openDetail(item)"
            >
              DETALHAR
            </v-btn>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 4px"
                    width="35"
                    height="35"
                    small
                    class="ma-1 table-button"
                    color="quaternary"
                    @click="editClient(item)"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 4px"
                    width="35"
                    height="35"
                    small
                    class="ma-1 remove-button"
                    color="red"
                    @click="deleteClient(item)"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon dark>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </section>
        </template>

        <template v-slot:[`header.download`]="{ header }">
          <v-btn
            outlined
            @click="generate"
            tile
            icon
            width="35"
            height="35"
            v-on="header"
            class="quinary-button"
            style="border-radius: 4px"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>

        <template v-slot:header.data-table-select="{ on, props}">
          <v-simple-checkbox
              color="#bc0000"
              v-bind="props"
              v-on="on"
              :ripple="false"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
          <v-simple-checkbox
              :ripple="false"
              @click="addUserListSelectedUser(item)"
              :value="isSelected"
              color="#bc0000"
              v-bind="props"
              v-on="on"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:footer >
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>

          <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedUsers.length > 0">
            <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <label>Selecione a ação</label>
              <v-select
                  class="ma-0 pa-0 "
                  dense
                  v-model="actionSelected"
                  outlined
                  style="border-radius: 3px!important"
                  :items="actions"
                  item-text="label"
                  item-value="value"
                  placeholder="Selecione a ação"
              >
              </v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
              <v-btn
                  class="secondary-button mt-5 ml-3"
                  style="height: 40px!important; border-radius: 7.5px!important"
                  height="40"
                  width="100%"
                  elevation="0"
                  :disabled="!actionSelected"
                  @click="confirmActionDialog = true"
              >
                {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="dialog" :key="dialogKey" max-width="760">
      <Detail :client="client" @close="close" />
    </v-dialog>

    <v-dialog v-model="manageDialog" max-width="600">
      <Manage
        :key="client.id"
        :clientProp="client"
        @close="manageDialog = false"
        @confirm="getClients(), (manageDialog = false)"
      />
    </v-dialog>

    <v-dialog v-model="removeDialog" max-width="400">
      <Remove
        :key="client.id"
        :clientProp="client"
        @close="removeDialog = false"
        @confirm="getClients(), (removeDialog = false)"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="actionSelected"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="removeUsers()"
      />
    </v-dialog>

    <v-dialog
        v-model="confirmActionRecordCannotDeleteModalDialog"
        max-width="700"
    >
      <RecordCannotDeleteModal
          :recordsCannotDelete="recordsCannotDelete"
          :title="titleRecordsCannotDelete"
          @close="(confirmActionRecordCannotDeleteModalDialog = false)"
      />
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "../../../services/ApiService";
import Detail from "./components/Detail.vue";
import HeaderClient from "./components/HeaderClient.vue";
import Manage from "./components/manage.vue";
import Remove from "./components/remove.vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import RecordCannotDeleteModal from "@/views/pages/components/RecordCannotDeleteModal.vue";
import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "Clients",

  components: {
    RecordCannotDeleteModal,
    ConfirmModal,
    Pagination,
    HeaderClient,
    Detail,
    Manage,
    Remove,
  },
  async created() {
    const jsonFilters = JSON.parse(localStorage.getItem("ordersCustomersFilters"));

    if (jsonFilters){
      this.filter = jsonFilters
      this.page = this.filter.page;
    }

    await this.getClients();
  },

  data: () => ({
    recordsCannotDelete: [],
    titleRecordsCannotDelete: "",
    confirmActionRecordCannotDeleteModalDialog: false,
    selectedUsers: [],
    actions: [
      { label: "Excluir cliente(s)", value: 1},
    ],
    actionSelected: null,
    confirmActionDialog: false,
    removeDialog: false,
    manageDialog: false,
    dialog: false,
    dialogKey: false,
    client: {},
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 10,
    states: [
      { sigla: 'DF', nome: 'Distrito Federal' },
      { sigla: 'ES', nome: 'Espírito Santo' },
      { sigla: 'GO', nome: 'Goiás' },
      { sigla: 'MA', nome: 'Maranhão' },
      { sigla: 'PA', nome: 'Pará' },
      { sigla: 'PB', nome: 'Paraíba' },
      { sigla: 'PE', nome: 'Pernambuco' },
      { sigla: 'MG', nome: 'Minas Gerais' },
      { sigla: 'MS', nome: 'Mato Grosso do Sul' },
      { sigla: 'MT', nome: 'Mato Grosso' },
      { sigla: 'AC', nome: 'Acre' },
      { sigla: 'AL', nome: 'Alagoas' },
      { sigla: 'AM', nome: 'Amazonas' },
      { sigla: 'AP', nome: 'Amapá' },
      { sigla: 'BA', nome: 'Bahia' },
      { sigla: 'CE', nome: 'Ceará' },
      { sigla: 'RJ', nome: 'Rio de Janeiro' },
      { sigla: 'PI', nome: 'Piauí' },
      { sigla: 'PR', nome: 'Paraná' },
      { sigla: 'RN', nome: 'Rio Grande do Norte' },
      { sigla: 'RO', nome: 'Rondônia' },
      { sigla: 'RR', nome: 'Roraima' },
      { sigla: 'RS', nome: 'Rio Grande do Sul' },
      { sigla: 'SC', nome: 'Santa Catarina' },
      { sigla: 'SE', nome: 'Sergipe' },
      { sigla: 'SP', nome: 'São Paulo' },
      { sigla: 'TO', nome: 'Tocantins' },
    ],
    clients: [{}],
    headers: [
      {
        text: "Nome",
        value: "name",
        sortable: false,
      },
      {
        text: "ID",
        value: "id",
        sortable: false,
      },
      {
        text: "E-mail",
        value: "email",
        sortable: false,
      },
      {
        text: "Estado",
        value: "state",
        sortable: false,
      },
      {
        text: "CPF/CNPJ",
        value: "cnpj",
        sortable: false,
      },
      {
        text: "Quantidade de pedidos",
        value: "quantityPurchasesWebsite",
        sortable: false,
      },
      {
        text: "Ações",
        align: "center",
        value: "actions",
        sortable: false,
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    orders: [
      {
        text: "Crescente cadastro",
        value: 0,
      },
      {
        text: "Decrescente cadastro",
        value: 1,
      },
      {
        text: "Crescente vendas",
        value: 2,
      },
      {
        text: "Decrescente vendas",
        value: 3,
      },
    ],
    loading: false,
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      email: null,
      cpfCnpj: null,
      phone: null,
      order: 1,
      state: null,
    },
    page: 1,
    apiService: new ApiService(),
  }),

  methods: {
    removeUsers(){
      try {
        this.recordsCannotDelete = [];
        this.confirmActionDialog = false;
        this.selectedUsers.forEach((user) => {
          const itens = []
          if (user.quantityPurchasesWebsite && user.quantityPurchasesWebsite > 0) {
            itens.push('Usuário tem pedidos relacionada')
          }
          if (user.userAddress && user.userAddress.length > 0) {
            itens.push('Usuário tem endereços relacionada')
          }
          if (user.quantityOrdersReview && user.quantityOrdersReview > 0) {
            itens.push('Usuário tem avaliações de pedidos relacionada')
          }
          if (user.quantityProductsReview && user.quantityProductsReview > 0) {
            itens.push('Usuário tem avaliações de produtos relacionada')
          }

          if (itens.length > 0){
            this.recordsCannotDelete.push(
                {
                  subTitle: `Usuário: <strong>${user.name}</strong>`,
                  motives: itens,
                }
            )
          }
        })
        if (this.recordsCannotDelete.length > 0) {
          this.confirmActionRecordCannotDeleteModalDialog = true
          this.confirmActionDialog = false
          this.titleRecordsCannotDelete = `Usuários que não podem serem excluídos`
          return
        }

        this.apiService.post('client/delete/list', this.selectedUsers).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Clientes excluídos com sucesso",
            trace: null,
          });
          await this.getClients();
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível excluir os clientes",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    addUserListSelectedUser(user){
      const userFind = this.selectedUsers.findIndex((x) => x.id === user.id)
      if (userFind > -1) {
        this.selectedUsers.splice(userFind, 1)
      } else {
        this.selectedUsers.push(user)
      }
    },

    editClient(item) {
      this.client = item;
      this.manageDialog = true;
    },

    deleteClient(item) {
      this.client = item;
      this.removeDialog = true;
    },

    generate() {
      this.loading = true;

      let now = new Date();
      const filename = `${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`;

      this.apiService
        .post("client/excel", this.filter)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
          this.$emit("close");
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getClients() {
      this.apiService
        .post("client/list", this.filter)
        .then((response) => {
          this.clients = response.clients;
          this.totalPages = response.pager.totalPages;
          this.totalItems = response.pager.totalItems;
          this.currentPage = response.pager.currentPage;
        })
        .catch((err) => {});
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.getClients();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.getClients();
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 10,
        name: null,
        email: null,
        cpfCnpj: null,
        phone: null,
        order: 1,
        state: null,
      };
      this.page = 1;
      this.getClients();
    },

    openDetail(item) {
      localStorage.setItem("ordersCustomersFilters", JSON.stringify(this.filter));
      this.client = item;
      this.dialog = true;
    },

    close() {
      this.dialogKey = !this.dialogKey;
      this.dialog = false;
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize;
      this.getClients();
    },
    page() {
      this.filter.page = this.page;
      this.getClients();
    },
  },
};
</script>

<style></style>
